<script>
	import { page } from '$app/stores'
	import { t } from '$lib/translations'

	const persons = [
		{
			locals: ['CS', 'DE', 'PL'],
			name: 'Vít Javůrek',
			job: 'CEO',
			photo: {
				src: '/images/persons/vit-javurek-2023.webp'
			}
		},
		{
			locals: ['CS', 'DE'],
			name: 'Dan Helcl',
			job: 'Group Procurement, Co-founder',
			photo: {
				src: '/images/persons/daniel-helcl-2023.webp'
			}
		},
		{
			locals: ['CS', 'DE'],
			name: 'Karel Náprstek',
			job: 'Group technical expert, Co-founder',
			photo: {
				src: '/images/persons/karel-naprstek-2023.webp'
			}
		},
		{
			locals: ['CS'],
			name: 'Jan Kadlec',
			job: 'Czech Country Manager',
			photo: {
				src: '/images/persons/jan_kadlec.webp'
			}
		},
		{
			locals: ['CS'],
			name: 'Miroslav Mužík',
			job: 'Logistics Manager',
			photo: {
				src: '/images/persons/miroslav_muzik.webp'
			}
		},
		// {
		// 	locals: ['CS'],
		// 	name: 'Žaneta Pavlíčková',
		// 	job: 'NextGen Projects',
		// 	photo: {
		// 		src: '/images/logos/woltair-favicon.webp'
		// 	}
		// },
		// {
		// 	locals: ['CS'],
		// 	name: 'Michal Černý',
		// 	job: 'Chief Product Officer',
		// 	photo: {
		// 		src: '/images/logos/woltair-favicon.webp'
		// 	}
		// },
		{
			locals: ['IT'],
			name: 'Emna Neifar',
			job: 'Country Manager',
			photo: {
				src: '/images/persons/italy/emna-neifar.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Giuseppe Masciale',
			job: 'Marketing Manager',
			photo: {
				src: '/images/persons/italy/giuseppe-masciale.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Karolina Kúthová',
			job: 'Customer Care Specialist',
			photo: {
				src: '/images/persons/italy/karolina-kuthova.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Simone Verduci',
			job: 'Head of Sales',
			photo: {
				src: '/images/persons/italy/simone-verduci.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Cleide Rizzo',
			job: 'Admin support',
			photo: {
				src: '/images/persons/italy/cleide-rizzo.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Mario Blancato',
			job: 'Tecnico / Coordinator',
			photo: {
				src: '/images/persons/italy/mario-blancato.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Oliviero Barone',
			job: 'Tecnico / Budgeter',
			photo: {
				src: '/images/persons/italy/oliviero-barone.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Esther Rupil',
			job: 'Customer Care Specialist',
			photo: {
				src: '/images/persons/italy/esther-rupil.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Davide Casto',
			job: 'Community Manager',
			photo: {
				src: '/images/persons/italy/davide-casto.webp'
			}
		},
		{
			locals: ['IT'],
			name: 'Marco Bellisario',
			job: 'Content Specialist',
			photo: {
				src: '/images/persons/italy/marco-bellisario.webp'
			}
		},
		{
			locals: ['PL'],
			name: 'Michał Borek',
			job: 'Country Manager Poland',
			photo: {
				src: '/images/persons/michal-borek.webp'
			}
		},
		{
			locals: ['PL'],
			name: 'Agata Borodziuk',
			job: 'Operations manager',
			photo: {
				src: '/images/persons/agata-borodziuk.webp'
			}
		},
		{
			locals: ['PL'],
			name: 'Michał Chaberski',
			job: 'Ekspert ds. pomp ciepła',
			photo: {
				src: '/images/persons/michal-chaberski.webp'
			}
		},
		{
			locals: ['PL'],
			name: 'Maciej Czapla',
			job: 'Ekspert ds. fotowoltaiki',
			photo: {
				src: '/images/persons/maciej-czapla.webp'
			}
		},
		{
			locals: ['PL'],
			name: 'Dominik Waligórski',
			job: 'Sales Manager',
			photo: {
				src: '/images/persons/dominik-waligorski.webp'
			}
		}
	]
</script>

<section class="page-wrapper mx-auto">
	<div class="text-wrapper flex w-full">
		<h3>{t('web.team.title')}</h3>
		<p>
			{t('web.team.description')}
		</p>
	</div>
</section>
<div class="persons page-wrapper mx-auto">
	{#each persons.filter( (p) => p.locals.includes($page.data.organization.lang) ) as { name, job, photo: { src } }}
		<div class="person">
			<img {src} alt={name} />
			<p class="name font-semibold">{name}</p>
			<p class="text-gray-light text-xs-res lg:text-sm">{job}</p>
		</div>
	{/each}
</div>

<style lang="scss">
	section {
		background: #e20613;
		margin: 100px 0;
		padding: 40px 40px 120px;
		position: relative;

		@screen lg {
			padding: 50px 50px 150px;
			margin: 75px auto;
		}

		.text-wrapper {
			display: flex;
			justify-content: space-between;
			gap: 3rem;

			@media (max-width: 760px) {
				flex-direction: column;
			}

			h3 {
				color: #fff;
				font-weight: 900;
				white-space: nowrap;
				width: fit-content;
				margin-top: 0;
			}

			p {
				margin: 0;
				color: #fff;
				font-weight: 400;

				@screen lg {
					flex-basis: 100%;
					flex-shrink: 0;
				}
			}
		}
	}

	.persons {
		position: relative;
		z-index: 1;
		margin-top: -180px;
		margin-bottom: 75px;
		padding: 0 40px;
		display: flex;
		gap: 30px;
		flex-wrap: wrap;
		justify-content: center;

		@media (max-width: 760px) {
			flex-direction: column;
			width: 100%;
		}

		.person {
			flex: 1 0 calc(20% - 30px);
			max-width: calc(20% - 30px);

			@media (max-width: 760px) {
				flex: 1 0 100%;
				max-width: 100%;
			}

			img {
				object-fit: contain;
				object-position: top;
				width: 100%;
			}

			p {
				margin: 5px 0;
			}
		}
	}
</style>
